import {DashboardSimpleCountResponse} from '../../models/dashboard/SimpleCountResponse';
import {DashboardMessageCountResponse} from '../../models/dashboard/MessageCountResponse';

export class DashboardState {
    loaded: boolean = false;
    products?: DashboardSimpleCountResponse = undefined;
    customers?: DashboardSimpleCountResponse = undefined;
    messages?: DashboardMessageCountResponse = undefined;
}